<template>
  <div>

<!--Breadcrumb-->
<div class="grid-container full">
  <div class="grid-container">

    <div class="grid-x grid-padding-y">
      <div class="cell">
        <nav aria-label="You are here:" role="navigation">
          <ul class="breadcrumbs">
            <li>
              <router-link to="/">
                Home
              </router-link>
            </li>
            <li>
              <span class="show-for-sr">Current: </span> About Us
            </li>
          </ul>
        </nav>      
      </div>

    </div>

  </div>  
</div>


<!--Introduction 1 -->
<div class="grid-container full container">
  <div class="grid-container ">
    <div class="grid-x">
      <div class="cell  top-banner large-10 large-centered" >
        <h1 class="text-center font-bold text-uppercase">
          About Us
        </h1>
      </div>
      <div class="cell container">
        <div class="grid-x grid-padding-x">
          <div class="cell medium-6">

            <img src="@/assets/images/about-ob1.jpg" class="radius " />

            <br />
            <br />
            <br />
            <br />
            <br />
            <br />

          </div>
          <div class="cell medium-6 text-center ">
            <div class="">
              <p class="text-justify ">
                O.N.E. is a professional team with 12 Years of experience in the field of international business & consulting between China and many other countries . We have also  well developed LCL&FCL logistic services between different countries for our clients. 
              </p>
            </div>


          </div>
        </div>
        <div class="grid-x grid-padding-x">

          <div class="cell medium-6  ">
            <div class="">
              <p class=" text-justify">
                At the same time, we have made ourselves specialist of consulting in commercial kitchen design & purchase, hotel & restaurant furniture design & purchase, exclusive distributors of a few brands of hand tools &amp; medical equipements. With strong base in Guangzhou China and well supported by business associates in Thailand, Cambodia, France, Spain , Egypt, Saudi Arabic, Bermuda and so on, we deeply believe that by choosing O.N.E, together you and us, we will enhance a blooming economic growth ,and thus accomplish or expand your business territory steadily.
              </p>
            </div>


          </div>

          <div class="cell medium-6 text-center">

            <img src="@/assets/images/about-ob2.jpg" class="radius" /> 

          </div>
        </div>
      </div>
    </div>
  </div>  
</div>

<!--Introduction 2 -->
<div class="grid-container full ">
  <div class="grid-container ">
    <div class="grid-x">
      <div class="cell  large-10 large-centered" >
        <h1 class="text-center font-bold">
          RECENT 
          <br />
          <p class="h5 secondary padding-top-1 " style="color: var(--third-color);">
            Fight against COVID-19
          </p>
        </h1>
      </div>
      <div class="cell container">

        <div class="grid-x grid-padding-x grid-padding-y">
          <div class="cell medium-6">

            <div class="grid-x">
              <div class="cell large-8 large-centered text-center">
                <div class="container">
                  <h1>
                    <i class="fi-marker"></i>
                  </h1>
                  <h5 class="font-bold padding-top-1 padding-bottom-1">
                    Since earlier January 2020
                  </h5>
                  <p class="text-justify">
                    We sensed the severity of the virus.Our team since then had been preparing to   trade in neccesssary products such as masks,respirators ,protection suits ect to solve the problem of shortage in China during the virus outbreak.With our rich experience in products quality and international transport of trading, our company successfully imported certain amount of qualified products in china and be part of it to help the nation to get through the difficult time of fighting against virus.

                  </p>
                </div>    
              </div>
            </div>



          </div>
          <div class="cell medium-6 text-center ">
            <div class="grid-x">
              <div class="cell large-8 large-centered text-center">
                <div class="container">
                  <h1>
                    <i class="fi-dollar"></i>
                  </h1>
                  <h5 class="font-bold padding-top-1 padding-bottom-1">
                    Along this time
                  </h5>
                  <p class="text-justify">
                   We are very aware of what kind of quality ,and what kind of products should be required for such circumstances, thus we are careful on choosing our partners in manufacturing as well as in purchasing.

                  </p>
                </div>    
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>  
</div>


<div id="maskbanner" class="position-relative container" style=""> 
  <div id="top-banner" class="grid-container full ">
    <div class="banner-content">
      <div class="grid-container text-center padding-top-3">
        <h4 class="padding-bottom-1 ">
          Keep In Touch
          &nbsp;
        </h4>
        
        <router-link :to="{ name: 'contact' }" class="text-uppercase button shadow radius large">
                    <i class="fi-telephone"></i>&nbsp;&nbsp; Contact
                  </router-link>
      

      </div>
    </div>

  </div>  
  <div class="container"></div>

  <div class="" style="background: url('/images/5be144b9-7edc-4762-832b-e9e38216ec3c.png');
              height: 100%;
              position: absolute;
              top: 0;
              width: 100%;
              overflow: hidden;
              background-repeat: no-repeat;
              z-index: -1;
              opacity: .5;">

  </div>
</div>


  </div>
</template>

<script>
import "owl.carousel";

export default {
  name: "aboutPage",
  mounted() {
    let { owlDemo } = this.$refs;

    var owl = $(owlDemo);
    owl.owlCarousel({
      loop: true,
      margin: 10,
      nav: false,
      items: 1,
    });

    // Custom Button
    $(".customNextBtn").click(function() {
      owl.trigger("next.owl.carousel");
    });
    $(".customPreviousBtn").click(function() {
      owl.trigger("prev.owl.carousel");
    });
  },
};
</script>
